import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../../../NavigationContainer.vue";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import SalesNoteLinkNavigation from "../../../KDPSalesNoteLinkNavigationContainer.vue";
import SalesNoteHeaderNavigation from "../../../KDPSalesNoteHeaderNavigationContainer.vue";
import TermsofServiceInfo1 from "../TermsofServiceInfo1.vue";
import TermsofServiceInfo2 from "../TermsofServiceInfo2.vue";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const btnNext = ref(true);
const showFlg = ref(1);
const kdpSalesNoteScreenFlg = ref("Issuse");
const tofInfoHeight = ref('calc(100% - 90px)');
var scrollEvent : any

onMounted(function () {
  if (store.getters.kdpSalesNoteScreen == "KDPConfirmSalesNote") {
    kdpSalesNoteScreenFlg.value = "Confirm";
    tofInfoHeight.value = 'calc(100% - 110px)'
  } 
});

// スクロールバー変更イベント
const scrollevent = (event : any) => {
  scrollEvent = event
  if (event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight - 25) {
    btnNext.value = false;
  }
};

// 次へボタンイベント
const goNext = () => {
    if (showFlg.value == 1) {
      showFlg.value = 2;
      scrollEvent.target.scrollTop = 0
      btnNext.value = true;
    } else {
      router.push("/ShowPDFFileByKDPSalesNote");
    } 
}

// Backボタンイベント
const goBack = () => {
      router.push("/KDPConfirmSalesNote");
}

const __returned__ = { router, btnNext, showFlg, kdpSalesNoteScreenFlg, tofInfoHeight, scrollEvent, scrollevent, goNext, goBack, Navigation, SalesNoteLinkNavigation, SalesNoteHeaderNavigation, TermsofServiceInfo1, TermsofServiceInfo2 }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})